<template>
  <input
    ref="inputEl"
    v-bind="$attrs"
    :value="modelValue"
    :id="computedId"
    @input="e => emit('update:modelValue', (e.target as HTMLInputElement).value)"
  />
</template>

<script setup lang="ts">
import { ref, computed} from 'vue'
const props = defineProps<{
   modelValue?: string,
   id?: string
   }>()
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const computedId = computed(() => props.id || 'base-input')
const inputEl = ref<HTMLInputElement | null>(null)
defineExpose({ inputEl })
</script>
